







// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import {
//   TextField, Button, Grid, Paper, Typography, MenuItem, Box,
//   Alert, CircularProgress, Chip, Stack, List, ListItem,
//   ListItemText, ListItemIcon, IconButton, Divider,
// } from '@mui/material';
// import { Editor } from '@tinymce/tinymce-react';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
// import VideoFileIcon from '@mui/icons-material/VideoFile';
// import LinkIcon from '@mui/icons-material/Link';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // Import PDF icon
// import { FormControlLabel, Checkbox } from '@mui/material';

// import { createNewsbyAdmin, uploadMediaFiles } from '../../../services/adminService';
// import {
//   getCategories,
//   getSubcategories,
//   getCountries,
//   getStatesByCountry,
//   getCitiesByState,
// } from '../../../services/apiService';

// const RASHI_OPTIONS = [
//   "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
//   "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
// ];

// const isValidUrl = (string) => {
//   try {
//     new URL(string);
//     return true;
//   } catch (e) {
//     return false;
//   }
// };

// const CreateNews = () => {
//   const [formData, setFormData] = useState({
//     title_en: '',
//     title_hi: '',
//     summary_en: '',
//     summary_hi: '',
//     content_en: '',
//     content_hi: '',
//     category: '',
//     subCategory: '',
//     subSubCategory: '',
//     tags: [],
//     mediaUrls: [],
//     referenceLinks: [],
//     localAddress: '',
//     status: '',
//     country: '',
//     state: '',
//     city: '',
//     isHeadline: false,
//     poll: { question: '', options: [] }
//   });

//   const [showEnglishFields, setShowEnglishFields] = useState(true);
//   const [showHindiFields, setShowHindiFields] = useState(true);

//   const [pollOptionInput, setPollOptionInput] = useState("");
//   const [currentTagInput, setCurrentTagInput] = useState('');
//   const [mediaFiles, setMediaFiles] = useState([]); // For images and videos
//   const [pdfFiles, setPdfFiles] = useState([]); // For PDF files
//   const [mediaUrlInput, setMediaUrlInput] = useState('');
//   const [referenceLinkInput, setReferenceLinkInput] = useState('');

//   const [categories, setCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const editorRefEn = useRef(null);
//   const editorRefHi = useRef(null);

//   // ✅ CRITICAL: Ref to track mediaUrls and avoid closure issues
//   const mediaUrlsRef = useRef([]);

//   // ✅ Keep ref in sync with state
//   useEffect(() => {
//     mediaUrlsRef.current = formData.mediaUrls;
//   }, [formData.mediaUrls]);


// // ✅ हेडलाइन के लिए स्पेशल कॉन्फ़िगरेशन (छोटा और सीधा)
//   // const headlineEditorConfig = {
//   //   height: 180,
//   //   menubar: false,
//   //   branding: false,
//   //   plugins: ['advlist', 'autolink', 'lists', 'link', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'wordcount'],
//   //   toolbar: 'undo redo | bold italic underline | forecolor backcolor | fontsizeselect | alignleft aligncenter alignright alignjustify | removeformat',
//   //   content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; }'
//   // };

//     const headlineEditorConfig = {
//     height: 180,
//     menubar: false,
//     branding: false,
//     plugins: [
//       'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview', 
//       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 
//       'insertdatetime', 'media', 'table', 'help', 'wordcount'
//     ],

//      // यह सुनिश्चित करेगा कि टेक्स्ट हमेशा <p> टैग में ही रहे
//   forced_root_block: 'p',
  
//   // अगर कोई बाहर से कलर या स्टाइल पेस्ट करे तो उसे हटा देगा
//   paste_as_text: true, 
//   invalid_styles: 'font-size font-family',
//     // 'fontsizeselect' ही वो बटन है जिससे साइज बदलता है
//     toolbar: 'undo redo | italic underline | fontsizeselect | forecolor backcolor | removeformat',
    
//     // यहाँ हमने साइज की लिस्ट दे दी है ताकि आप बहुत बड़ा साइज भी चुन सकें
//     fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
    
//     content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; }'
//   };





//   const editorConfig = {
//     height: 500,
//     menubar: true,
//     branding: false,
//     plugins: [
//       'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
//       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
//       'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
//       'template', 'codesample', 'hr', 'pagebreak', 'nonbreaking',
//       'toc', 'imagetools', 'textpattern', 'noneditable', 'quickbars',
//       'accordion', 'autosave', 'save', 'directionality', 'visualchars'
//     ],
//     toolbar1: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify',
//     toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save print',
//     toolbar3: 'insertfile image media template link anchor codesample | customupload | ltr rtl | showcomments addcomment',

//     content_style: `
//     body {
//       font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
//       font-size: 14px;
//       line-height: 1.6;
//       margin: 1rem;
//     }
//     img { max-width: 100%; height: auto; }
//     .mce-content-body {
//       padding: 20px;
//       max-width: none;
//     }
//     .left { text-align: left; }
//     .center { text-align: center; }
//     .right { text-align: right; }
//     .full { text-align: justify; }
//   `,

//     paste_data_images: true,
//     automatic_uploads: true,
//     file_picker_types: 'image media',

//     file_picker_callback: function (callback, value, meta) {
//       console.log('File picker triggered for:', meta.filetype);

//       const input = document.createElement('input');
//       input.setAttribute('type', 'file');

//       if (meta.filetype === 'image') {
//         input.setAttribute('accept', 'image/*');
//       } else if (meta.filetype === 'media') {
//         input.setAttribute('accept', 'video/*,audio/*');
//       } else {
//         input.setAttribute('accept', 'image/*,video/*,audio/*');
//       }

//       input.onchange = function () {
//         const file = this.files[0];

//         if (!file) {
//           console.log('No file selected');
//           return;
//         }

//         console.log('File selected:', file.name, file.type, file.size);

//         const editor = window.tinymce.activeEditor;
//         editor.setProgressState(true);

//         const formData = new FormData();
//         formData.append('mediaFiles', file); // Append as mediaFiles, backend will differentiate PDF

//         uploadMediaFiles(formData)
//           .then(response => {
//             console.log('✅ Upload response:', response);
//             editor.setProgressState(false);

//             if (response && response.locations && response.locations.length > 0) {
//               const uploadedUrl = response.locations[0];
//               console.log('✅ Actual URL from server:', uploadedUrl);

//               // ✅ Use ref to avoid closure issue
//               const currentUrls = [...mediaUrlsRef.current];
//               if (!currentUrls.includes(uploadedUrl)) {
//                 currentUrls.push(uploadedUrl);
//                 mediaUrlsRef.current = currentUrls;

//                 setFormData(prev => ({
//                   ...prev,
//                   mediaUrls: currentUrls
//                 }));
//               }

//               // ✅ Pass actual URL to callback
//               callback(uploadedUrl, {
//                 title: file.name,
//                 alt: file.name
//               });

//               editor.notificationManager.open({
//                 text: `File "${file.name}" uploaded successfully!`,
//                 type: 'success',
//                 timeout: 3000
//               });

//               console.log('✅ Current mediaUrls:', currentUrls);
//             } else {
//               throw new Error('No URL returned from upload service');
//             }
//           })
//           .catch(error => {
//             console.error('❌ Upload failed:', error);
//             editor.setProgressState(false);

//             editor.notificationManager.open({
//               text: `Upload failed: ${error.message || 'Unknown error'}`,
//               type: 'error',
//               timeout: 5000
//             });

//             alert(`File upload failed: ${error.message || 'Please try again'}`);
//           });
//       };

//       input.click();
//     },

//     images_upload_handler: function (blobInfo, success, failure, progress) {
//       console.log('Image upload handler triggered');
//       console.log('Blob info:', blobInfo.filename(), blobInfo.blob().type, blobInfo.blob().size);

//       const blob = blobInfo.blob();
//       const blobUri = blobInfo.blobUri(); // ✅ Get the blob URI that TinyMCE created

//       const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, {
//         type: blob.type || 'image/png'
//       });

//       console.log('Created file object:', file);
//       console.log('Blob URI (temporary):', blobUri);

//       const formData = new FormData();
//       formData.append('mediaFiles', file); // Append as mediaFiles

//       const editor = window.tinymce.activeEditor;
//       editor.setProgressState(true);

//       uploadMediaFiles(formData)
//         .then(response => {
//           console.log('✅ Upload response:', response);
//           editor.setProgressState(false);

//           if (response && response.locations && response.locations.length > 0) {
//             const uploadedUrl = response.locations[0];
//             console.log('✅ Actual URL from server:', uploadedUrl);

//             // ✅ Use ref to avoid closure issue
//             const currentUrls = [...mediaUrlsRef.current];
//             if (!currentUrls.includes(uploadedUrl)) {
//               currentUrls.push(uploadedUrl);
//               mediaUrlsRef.current = currentUrls;

//               setFormData(prev => ({
//                 ...prev,
//                 mediaUrls: currentUrls
//               }));
//             }

//             // ✅ CRITICAL: Replace blob/base64 URLs with actual URL in editor content
//             const content = editor.getContent();

//             // Replace blob URI
//             if (blobUri && content.includes(blobUri)) {
//               const updatedContent = content.replace(new RegExp(blobUri, 'g'), uploadedUrl);
//               editor.setContent(updatedContent);
//               console.log('✅ Replaced blob URI with actual URL in content');
//             }

//             // Replace base64 data URLs (in case they exist)
//             const base64Pattern = new RegExp(`<img[^>]*src="data:image/[^;]+;base64,[^"]*"[^>]*>`, 'gi');
//             const currentContent = editor.getContent();
//             const matches = currentContent.match(base64Pattern);

//             if (matches && matches.length > 0) {
//               // Replace the last base64 image (most recently pasted) with actual URL
//               const lastBase64Match = matches[matches.length - 1];
//               const updatedContent = currentContent.replace(
//                 lastBase64Match,
//                 `<img src="${uploadedUrl}" alt="${file.name}" style="max-width: 100%; height: auto;" />`
//               );
//               editor.setContent(updatedContent);
//               console.log('✅ Replaced base64 image with actual URL in content');
//             }

//             // ✅ Pass actual URL to success callback
//             success(uploadedUrl);

//             editor.notificationManager.open({
//               text: `Image uploaded successfully!`,
//               type: 'success',
//               timeout: 3000
//             });

//             console.log('✅ Current mediaUrls:', currentUrls);
//           } else {
//             throw new Error('No URL returned from upload service');
//           }
//         })
//         .catch(error => {
//           console.error('❌ Image upload failed:', error);
//           editor.setProgressState(false);

//           failure(`Upload failed: ${error.message || 'Unknown error'}`);

//           editor.notificationManager.open({
//             text: `Upload failed: ${error.message || 'Unknown error'}`,
//             type: 'error',
//             timeout: 5000
//           });
//         });
//     },

//     setup: function (editor) {
//       console.log('TinyMCE editor setup starting');

//       editor.on('init', function () {
//         console.log('TinyMCE editor initialized');
//         editor.getContainer().style.transition = "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out";
//       });

//       editor.ui.registry.addButton('customupload', {
//         text: 'Upload Media',
//         icon: 'upload',
//         tooltip: 'Upload images or videos',
//         onAction: function () {
//           console.log('Custom upload button clicked');

//           const input = document.createElement('input');
//           input.setAttribute('type', 'file');
//           input.setAttribute('accept', 'image/*,video/*');
//           input.setAttribute('multiple', 'true');

//           input.onchange = function () {
//             const files = Array.from(this.files);
//             console.log('Multiple files selected:', files.length);

//             if (files.length === 0) return;

//             editor.setProgressState(true);

//             const formData = new FormData();
//             files.forEach(file => {
//               formData.append('mediaFiles', file); // Append as mediaFiles
//               console.log('Adding file to FormData:', file.name);
//             });

//             uploadMediaFiles(formData)
//               .then(response => {
//                 console.log('✅ Batch upload response:', response);
//                 editor.setProgressState(false);

//                 if (response && response.locations && response.locations.length > 0) {
//                   // ✅ Use ref to avoid closure issue
//                   const currentUrls = [...mediaUrlsRef.current];
//                   const newUrls = response.locations.filter(url => !currentUrls.includes(url));
//                   const updatedUrls = [...currentUrls, ...newUrls];

//                   mediaUrlsRef.current = updatedUrls;

//                   setFormData(prev => ({
//                     ...prev,
//                     mediaUrls: updatedUrls
//                   }));

//                   response.locations.forEach((url, index) => {
//                     const file = files[index];
//                     console.log('✅ Inserting actual URL:', url);

//                     if (file && file.type.startsWith('image/')) {
//                       editor.insertContent(`<img src="${url}" alt="${file.name}" style="max-width: 100%; height: auto;" />`);
//                     } else if (file && file.type.startsWith('video/')) {
//                       editor.insertContent(`<video controls style="max-width: 100%; height: auto;">
//                       <source src="${url}" type="${file.type}">
//                       Your browser does not support the video tag.
//                     </video>`);
//                     }
//                   });

//                   editor.notificationManager.open({
//                     text: `Successfully uploaded ${response.locations.length} file(s)!`,
//                     type: 'success',
//                     timeout: 3000
//                   });

//                   console.log('✅ Current mediaUrls:', updatedUrls);
//                 } else {
//                   throw new Error('No URLs returned from upload service');
//                 }
//               })
//               .catch(error => {
//                 console.error('❌ Batch upload failed:', error);
//                 editor.setProgressState(false);

//                 editor.notificationManager.open({
//                   text: `Upload failed: ${error.message || 'Unknown error'}`,
//                   type: 'error',
//                   timeout: 5000
//                 });
//               });
//           };

//           input.click();
//         }
//       });

//       editor.on('drop', function (e) {
//         console.log('File(s) dropped on editor');
//       });

//       editor.on('paste', function (e) {
//         console.log('Content pasted into editor');
//       });
//     },

//     contextmenu: 'link image imagetools table',
//     quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
//     quickbars_insert_toolbar: 'quickimage quicktable customupload',
//     powerpaste_word_import: 'clean',
//     powerpaste_html_import: 'clean',

//     image_advtab: true,
//     image_uploadtab: true,
//     image_caption: true,
//     image_title: true,

//     template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
//     template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',

//     formats: {
//       alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
//       aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
//       alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
//       alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
//       bold: { inline: 'strong' },
//       italic: { inline: 'em' },
//       underline: { inline: 'u' },
//       strikethrough: { inline: 'del' },
//       customformat: { inline: 'span', styles: { color: '#00ff00', fontSize: '20px' }, attributes: { title: 'My custom format' }, classes: 'example1' }
//     }
//   };

//   useEffect(() => {
//     const fetchInitialDropdownData = async () => {
//       try {
//         const [catsRes, countriesRes] = await Promise.all([
//           getCategories(),
//           getCountries(),
//         ]);
//         setCategories(catsRes.data);
//         setCountries(countriesRes.data);
//       } catch (err) {
//         setError("Failed to load initial dropdown data (categories/countries).");
//         console.error("Error fetching initial dropdown data:", err);
//       }
//     };
//     fetchInitialDropdownData();
//   }, []);

//   const fetchSubCategoriesData = useCallback(async () => {
//     if (formData.category) {
//       try {
//         const response = await getSubcategories(formData.category);
//         setSubCategories(response.data);
//       } catch (err) {
//         setError("Failed to load subcategories.");
//         console.error("Error fetching subcategories:", err);
//         setSubCategories([]);
//       }
//     } else {
//       setSubCategories([]);
//     }
//     setFormData(prev => ({ ...prev, subCategory: '', subSubCategory: '' }));
//   }, [formData.category]);

//   useEffect(() => {
//     fetchSubCategoriesData();
//   }, [fetchSubCategoriesData]);

//   const fetchStatesData = useCallback(async () => {
//     if (formData.country) {
//       try {
//         const response = await getStatesByCountry(formData.country);
//         setStates(response.data);
//       } catch (err) {
//         setError("Failed to load states.");
//         console.error("Error fetching states:", err);
//         setStates([]);
//       }
//     } else {
//       setStates([]);
//     }
//     setFormData(prev => ({ ...prev, state: '', city: '' }));
//   }, [formData.country]);

//   useEffect(() => {
//     fetchStatesData();
//   }, [fetchStatesData]);

//   const fetchCitiesData = useCallback(async () => {
//     if (formData.state) {
//       try {
//         const response = await getCitiesByState(formData.state);
//         setCities(response.data);
//       } catch (err) {
//         setError("Failed to load cities.");
//         console.error("Error fetching cities:", err);
//         setCities([]);
//       }
//     } else {
//       setCities([]);
//     }
//     setFormData(prev => ({ ...prev, city: '' }));
//   }, [formData.state]);

//   useEffect(() => {
//     fetchCitiesData();
//   }, [fetchCitiesData]);

//   const selectedCategoryName = categories.find(cat => cat._id === formData.category)?.name?.toLowerCase();
//   const selectedSubCategoryName = subCategories.find(sub => sub._id === formData.subCategory)?.name?.toLowerCase();
//   const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setFormErrors((prev) => ({ ...prev, [name]: '' }));
//   };

//   const handleEditorChange = (content, name) => {
//     setFormData(prev => ({ ...prev, [name]: content }));
//     setFormErrors(prev => ({ ...prev, [name]: '' }));
//   };

//   const handleTagInputChange = (e) => {
//     setCurrentTagInput(e.target.value);
//   };

//   const handleAddTag = (e) => {
//     if (e.key === 'Enter' || e.key === ',') {
//       e.preventDefault();
//       const newTag = currentTagInput.trim();
//       if (newTag && !formData.tags.includes(newTag)) {
//         setFormData(prev => ({
//           ...prev,
//           tags: [...prev.tags, newTag]
//         }));
//         setCurrentTagInput('');
//       }
//     }
//   };

//   const handleDeleteTag = (tagToDelete) => () => {
//     setFormData(prev => ({
//       ...prev,
//       tags: prev.tags.filter(tag => tag !== tagToDelete)
//     }));
//   };

//   // Handler for image/video files
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     setMediaFiles(prevFiles => {
//       const newFiles = files.filter(
//         newFile => !prevFiles.some(existingFile => existingFile.name === newFile.name && existingFile.size === newFile.size)
//       );
//       return [...prevFiles, ...newFiles];
//     });
//     e.target.value = '';
//   };

//   // Handler for PDF files
//   const handlePdfFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     setPdfFiles(prevFiles => {
//       const newFiles = files.filter(
//         newFile => !prevFiles.some(existingFile => existingFile.name === newFile.name && existingFile.size === newFile.size)
//       );
//       return [...prevFiles, ...newFiles];
//     });
//     e.target.value = ''; // Clear the input so same file can be selected again
//   };

//   // Remove handler for image/video files
//   const handleRemoveMediaFile = (fileToRemove) => () => {
//     setMediaFiles(prevFiles => prevFiles.filter(file => file !== fileToRemove));
//   };

//   // Remove handler for PDF files
//   const handleRemovePdfFile = (fileToRemove) => () => {
//     setPdfFiles(prevFiles => prevFiles.filter(file => file !== fileToRemove));
//   };

//   const handleMediaUrlInputChange = (e) => {
//     setMediaUrlInput(e.target.value);
//     setFormErrors((prev) => ({ ...prev, mediaUrlInput: '' }));
//   };

//   const handleAddMediaUrl = () => {
//     const url = mediaUrlInput.trim();
//     if (url) {
//       if (!isValidUrl(url)) {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
//         return;
//       }
//       if (!formData.mediaUrls.includes(url)) {
//         setFormData(prev => ({
//           ...prev,
//           mediaUrls: [...prev.mediaUrls, url]
//         }));
//         setMediaUrlInput('');
//       } else {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
//       }
//     }
//   };

//   const handleRemoveMediaUrl = (urlToRemove) => () => {
//     setFormData(prev => ({
//       ...prev,
//       mediaUrls: prev.mediaUrls.filter(url => url !== urlToRemove)
//     }));
//   };

//   const handleReferenceLinkInputChange = (e) => {
//     setReferenceLinkInput(e.target.value);
//     setFormErrors((prev) => ({ ...prev, referenceLinkInput: '' }));
//   };

//   const handleAddReferenceLink = () => {
//     const link = referenceLinkInput.trim();
//     if (link) {
//       if (!isValidUrl(link)) {
//         setFormErrors((prev) => ({ ...prev, referenceLinkInput: 'Please enter a valid URL.' }));
//         return;
//       }
//       if (!formData.referenceLinks.includes(link)) {
//         setFormData(prev => ({
//           ...prev,
//           referenceLinks: [...prev.referenceLinks, link]
//         }));
//         setReferenceLinkInput('');
//       } else {
//         setFormErrors((prev) => ({ ...prev, referenceLinkInput: 'This link has already been added.' }));
//       }
//     }
//   };

//   const handleRemoveReferenceLink = (linkToRemove) => () => {
//     setFormData(prev => ({
//       ...prev,
//       referenceLinks: prev.referenceLinks.filter(link => link !== linkToRemove)
//     }));
//   };

//   const handlePollChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       poll: { ...prev.poll, [name]: value },
//     }));
//   };

//   const handleAddPollOption = () => {
//     const newOption = pollOptionInput.trim();
//     if (newOption && !formData.poll.options.includes(newOption)) {
//       setFormData((prev) => ({
//         ...prev,
//         poll: { ...prev.poll, options: [...prev.poll.options, newOption] },
//       }));
//       setPollOptionInput("");
//     }
//   };

//   const handleDeletePollOption = (optToDelete) => () => {
//     setFormData((prev) => ({
//       ...prev,
//       poll: {
//         ...prev.poll,
//         options: prev.poll.options.filter((o) => o !== optToDelete),
//       },
//     }));
//   };

//   const validateForm = () => {
//     let errors = {};
//     let isValid = true;

//     if (!showEnglishFields && !showHindiFields) {
//         errors.languageSelection = 'Please select at least one language (English or Hindi) to create news.';
//         isValid = false;
//     }

//     if (showEnglishFields) {
//         if (!formData.title_en.trim()) {
//             errors.title_en = 'Title (English) is required.';
//             isValid = false;
//         }

//         if (!formData.content_en.trim()) {
//             errors.content_en = 'Content (English) is required.';
//             isValid = false;
//         } else if (formData.content_en.trim().length < 20) {
//             errors.content_en = 'Content (English) must be at least 20 characters.';
//             isValid = false;
//         } else if (formData.content_en.trim().length > 1000000) {
//             errors.content_en = 'Content (English) cannot exceed 10000 characters.';
//             isValid = false;
//         }
//         if (formData.summary_en.trim().length > 500) {
//             errors.summary_en = 'Summary (English) cannot exceed 500 characters.';
//             isValid = false;
//         }
//     }

//     if (showHindiFields) {
//         if (!formData.title_hi.trim()) {
//             errors.title_hi = 'शीर्षक (हिंदी) आवश्यक है।';
//             isValid = false;
//         }

//         if (!formData.content_hi.trim()) {
//             errors.content_hi = 'सामग्री (हिंदी) आवश्यक है।';
//             isValid = false;
//         }
//         if (formData.summary_hi.trim().length > 500) {
//             errors.summary_hi = 'सारांश (हिंदी) 500 अक्षरों से अधिक नहीं हो सकता।';
//             isValid = false;
//         }
//     }

//     const hasValidEnglish = showEnglishFields && formData.title_en.trim() && formData.content_en.trim();
//     const hasValidHindi = showHindiFields && formData.title_hi.trim() && formData.content_hi.trim();

//     if (!hasValidEnglish && !hasValidHindi && (showEnglishFields || showHindiFields)) {
//         errors.noValidContent = 'At least one of English or Hindi news must have a title and content.';
//         isValid = false;
//     }

//     if (!formData.category) {
//         errors.category = 'Category is required.';
//         isValid = false;
//     }

//     setFormErrors(errors);
//     return isValid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     setSuccessMessage(null);
//     setFormErrors({});

//     const finalTags = [...formData.tags];
//     const remainingTag = currentTagInput.trim();
//     if (remainingTag && !finalTags.includes(remainingTag)) {
//       finalTags.push(remainingTag);
//     }

//     let updatedMediaUrls = [...formData.mediaUrls];
//     const currentMediaUrl = mediaUrlInput.trim();
//     if (currentMediaUrl) {
//       if (!isValidUrl(currentMediaUrl)) {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
//         setLoading(false);
//         setError("Please correct the errors in the form.");
//         return;
//       }
//       if (!updatedMediaUrls.includes(currentMediaUrl)) {
//         updatedMediaUrls.push(currentMediaUrl);
//       } else {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
//         setLoading(false);
//         setError("Please correct the errors in the form.");
//         return;
//       }
//     }

//     let updatedReferenceLinks = [...formData.referenceLinks];
//     const currentReferenceLink = referenceLinkInput.trim();
//     if (currentReferenceLink) {
//       if (!isValidUrl(currentReferenceLink)) {
//         setFormErrors((prev) => ({ ...prev, referenceLinkInput: 'Please enter a valid URL.' }));
//         setLoading(false);
//         setError("Please correct the errors in the form.");
//         return;
//       }
//       if (!updatedReferenceLinks.includes(currentReferenceLink)) {
//         updatedReferenceLinks.push(currentReferenceLink);
//       } else {
//         setFormErrors((prev) => ({ ...prev, referenceLinkInput: 'This link has already been added.' }));
//         setLoading(false);
//         setError("Please correct the errors in the form.");
//         return;
//       }
//     }

//     if (!validateForm()) {
//       setLoading(false);
//       setError("Please correct the errors in the form.");
//       return;
//     }

//     const dataToSend = new FormData();

//     if (showEnglishFields) {
//       dataToSend.append('title_en', formData.title_en.trim());
//       dataToSend.append('summary_en', formData.summary_en.trim());
//       dataToSend.append('content_en', formData.content_en.trim());
//     } else {
//       dataToSend.append('title_en', '');
//       dataToSend.append('summary_en', '');
//       dataToSend.append('content_en', '');
//     }

//     if (showHindiFields) {
//       dataToSend.append('title_hi', formData.title_hi.trim());
//       dataToSend.append('summary_hi', formData.summary_hi.trim());
//       dataToSend.append('content_hi', formData.content_hi.trim());
//     } else {
//       dataToSend.append('title_hi', '');
//       dataToSend.append('summary_hi', '');
//       dataToSend.append('content_hi', '');
//     }

//     dataToSend.append('category', formData.category);

//     if (formData.subCategory) dataToSend.append('subCategory', formData.subCategory);
//     if (formData.subSubCategory) dataToSend.append('subSubCategory', formData.subSubCategory);
//     if (formData.isHeadline) dataToSend.append('isHeadline', true);
//     if (formData.country) dataToSend.append('country', formData.country);
//     if (formData.state) dataToSend.append('state', formData.state);
//     if (formData.city) dataToSend.append('city', formData.city);

//     finalTags.forEach(tag => {
//       dataToSend.append('tags', tag);
//     });

//     if (formData.localAddress) dataToSend.append('localAddress', formData.localAddress.trim());

//     // Append image/video files
//     mediaFiles.forEach((file) => {
//       dataToSend.append('mediaFiles', file);
//     });

//     // Append PDF files - The backend will differentiate these by mimetype
//     pdfFiles.forEach((file) => {
//       dataToSend.append('mediaFiles', file);
//     });

//     // ✅ CRITICAL: Combine manually added URLs + editor uploaded URLs from ref
//     console.log('📤 Manually added URLs:', updatedMediaUrls);
//     console.log('📤 Editor uploaded URLs (from ref):', mediaUrlsRef.current);

//     const uniqueMediaUrls = [...new Set([...updatedMediaUrls, ...mediaUrlsRef.current])];
//     console.log('📤 Final unique mediaUrls to submit:', uniqueMediaUrls);

//     uniqueMediaUrls.forEach((url) => {
//       dataToSend.append('mediaUrls', url);
//     });

//     updatedReferenceLinks.forEach((link) => {
//       dataToSend.append('referenceLinks', link);
//     });

//     if (formData.poll.question.trim() && formData.poll.options.length > 0) {
//       dataToSend.append("poll[question]", formData.poll.question.trim());
//       formData.poll.options.forEach((opt, i) => {
//         dataToSend.append(`poll[options][${i}]`, opt.trim());
//       });
//     }

//     try {
//       const response = await createNewsbyAdmin(dataToSend);
//       setSuccessMessage(response.message || 'News created successfully!');

//       setFormData({
//         title_en: '',
//         title_hi: '',
//         summary_en: '',
//         summary_hi: '',
//         content_en: '',
//         content_hi: '',
//         category: '',
//         subCategory: '',
//         subSubCategory: '',
//         tags: [],
//         mediaUrls: [],
//         referenceLinks: [],
//         localAddress: '',
//         status: '',
//         country: '',
//         state: '',
//         city: '',
//         isHeadline: false,
//         poll: { question: '', options: [] }
//       });

//       mediaUrlsRef.current = [];

//       setPollOptionInput('');
//       setCurrentTagInput('');
//       setMediaFiles([]);
//       setPdfFiles([]); // Reset PDF files
//       setMediaUrlInput('');
//       setReferenceLinkInput('');
//       setSubCategories([]);
//       setStates([]);
//       setCities([]);

//       if (editorRefEn.current) editorRefEn.current.setContent('');
//       if (editorRefHi.current) editorRefHi.current.setContent('');
//     } catch (err) {
//       setError(err.response?.data?.message || err.message || 'Failed to create news.');
//       console.error('Error creating news:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Grid container justifyContent="center" sx={{ mt: 4, mb: 4 }}>
//       <Grid item xs={12} md={10} lg={8}>
//         <Paper elevation={3} sx={{ p: 4 }}>
//           <Typography
//             variant="h5"
//             align="center"
//             gutterBottom
//             sx={{
//               fontWeight: "bold",
//               color: "primary.main",
//               textTransform: "uppercase",
//               letterSpacing: 1.5,
//               mb: 3,
//             }}
//           >
//             📰 Create New News Post (Advanced Editor)
//           </Typography>

//           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
//           {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}

//           <form onSubmit={handleSubmit}>
//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                 Select Content Languages
//               </Typography>
//               <Stack direction="row" spacing={3}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={showEnglishFields}
//                       onChange={(e) => setShowEnglishFields(e.target.checked)}
//                       name="showEnglishFields"
//                       color="primary"
//                     />
//                   }
//                   label="English Fields"
//                 />
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={showHindiFields}
//                       onChange={(e) => setShowHindiFields(e.target.checked)}
//                       name="showHindiFields"
//                       color="primary"
//                     />
//                   }
//                   label="Hindi Fields"
//                 />
//               </Stack>
//             </Box>
//             <Divider sx={{ my: 3 }} />

//             {showEnglishFields && (
//               <Box sx={{ mb: 4, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
//                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
//                   English Content
//                 </Typography>
//              <Box sx={{ border: formErrors.title_en ? '1px solid red' : '1px solid #ccc', borderRadius: 1, mb: 2 }}>
//                     <Editor
//                         apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
//                         init={headlineEditorConfig}
//                         value={formData.title_en}
//                         onEditorChange={(content) => handleEditorChange(content, 'title_en')}
//                     />
//                 </Box>
//                   {formErrors.title_en && <Typography color="error" variant="caption">{formErrors.title_en}</Typography>}
//                 <TextField
//                   label="Summary (English)"
//                   name="summary_en"
//                   value={formData.summary_en}
//                   onChange={handleChange}
//                   fullWidth
//                   multiline
//                   rows={2}
//                   margin="normal"
//                   inputProps={{ maxLength: 500 }}
//                   error={!!formErrors.summary_en}
//                   helperText={formErrors.summary_en}
//                 />
//                 <Box sx={{ mt: 3, mb: 3 }}>
//                   <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
//                     Content (English) * (MS Word-like Editor)
//                   </Typography>
//                   <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
//                     <Editor
//                       apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
//                       onInit={(evt, editor) => editorRefEn.current = editor}
//                       init={editorConfig}
//                       value={formData.content_en}
//                       onEditorChange={(content) => handleEditorChange(content, 'content_en')}
//                     />
//                   </Box>
//                   {formErrors.content_en && (
//                     <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
//                       {formErrors.content_en}
//                     </Typography>
//                   )}
//                   <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
//                     Use the toolbar above for rich text formatting, tables, images, links, and more. You can paste directly from MS Word!
//                   </Typography>
//                 </Box>
//               </Box>
//             )}

//             {showHindiFields && (
//               <Box sx={{ mb: 4, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
//                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
//                   हिंदी सामग्री
//                 </Typography>
//                 <Box sx={{ border: formErrors.title_hi ? '1px solid red' : '1px solid #ccc', borderRadius: 1, mb: 2 }}>
//                     <Editor
//                         apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
//                         init={headlineEditorConfig}
//                         value={formData.title_hi}
//                         onEditorChange={(content) => handleEditorChange(content, 'title_hi')}
//                     />
//                 </Box>
//                 {formErrors.title_hi && <Typography color="error" variant="caption">{formErrors.title_hi}</Typography>}
//                 <TextField
//                   label="सारांश (हिंदी)"
//                   name="summary_hi"
//                   value={formData.summary_hi}
//                   onChange={handleChange}
//                   fullWidth
//                   multiline
//                   rows={2}
//                   margin="normal"
//                   inputProps={{ maxLength: 500 }}
//                   error={!!formErrors.summary_hi}
//                   helperText={formErrors.summary_hi}
//                 />
//                 <Box sx={{ mt: 3, mb: 3 }}>
//                   <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
//                     सामग्री (हिंदी) * (MS Word जैसा एडिटर)
//                   </Typography>
//                   <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
//                     <Editor
//                       apiKey="tdqbnxhth99nqmhdy4dmearws4a1teixkl1220nwcnxwhro9"
//                       onInit={(evt, editor) => editorRefHi.current = editor}
//                       init={editorConfig}
//                       value={formData.content_hi}
//                       onEditorChange={(content) => handleEditorChange(content, 'content_hi')}
//                     />
//                   </Box>
//                   {formErrors.content_hi && (
//                     <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
//                       {formErrors.content_hi}
//                     </Typography>
//                   )}
//                   <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
//                     टूलबार का उपयोग करके रिच टेक्स्ट फॉर्मेटिंग, टेबल, चित्र, लिंक आदि जोड़ें। आप सीधे MS Word से पेस्ट कर सकते हैं!
//                   </Typography>
//                 </Box>
//               </Box>
//             )}

//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   label="Category"
//                   name="category"
//                   select
//                   value={formData.category}
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                   error={!!formErrors.category}
//                   helperText={formErrors.category || "Select the primary category for this news."}
//                 >
//                   <MenuItem value="">Select Category</MenuItem>
//                   {categories.map(cat => <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>)}
//                 </TextField>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   label="Subcategory"
//                   name="subCategory"
//                   select
//                   value={formData.subCategory}
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                   disabled={!formData.category || subCategories.length === 0}
//                   helperText="Select a subcategory if available (optional)."
//                 >
//                   <MenuItem value="">Select Subcategory (Optional)</MenuItem>
//                   {subCategories.map(sub => <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>)}
//                 </TextField>
//               </Grid>
//             </Grid>

//             {showSubSubCategoryDropdown && (
//               <TextField
//                 label="Select Rashi (subSubCategory)"
//                 name="subSubCategory"
//                 select
//                 fullWidth
//                 margin="normal"
//                 value={formData.subSubCategory}
//                 onChange={handleChange}
//               >
//                 <MenuItem value="">Select Rashi</MenuItem>
//                 {RASHI_OPTIONS.map(r => (
//                   <MenuItem key={r} value={r}>{r}</MenuItem>
//                 ))}
//               </TextField>
//             )}

//             <Grid container spacing={1}>
//               <Grid item xs={12} sm={4}>
//                 <TextField
//                   label="Country"
//                   name="country"
//                   select
//                   value={formData.country}
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                   helperText="Select the country where the news originates."
//                 >
//                   <MenuItem value="">Select Country (Optional)</MenuItem>
//                   {countries.map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
//                 </TextField>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField
//                   label="State"
//                   name="state"
//                   select
//                   value={formData.state}
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                   disabled={!formData.country || states.length === 0}
//                   helperText="Select the state (optional)."
//                 >
//                   <MenuItem value="">Select State (Optional)</MenuItem>
//                   {states.map(s => <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>)}
//                 </TextField>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField
//                   label="City/District"
//                   name="city"
//                   select
//                   value={formData.city}
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                   disabled={!formData.state || cities.length === 0}
//                   helperText="Select the city or district (optional)."
//                 >
//                   <MenuItem value="">Select City/District (Optional)</MenuItem>
//                   {cities.map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
//                 </TextField>
//               </Grid>
//             </Grid>

//             <TextField
//               label="Local Address (Optional)"
//               name="localAddress"
//               value={formData.localAddress}
//               onChange={handleChange}
//               fullWidth
//               margin="normal"
//               inputProps={{ maxLength: 200 }}
//             />

//             <TextField
//               label="Tags (Type, then press Enter or comma)"
//               name="tagsInput"
//               value={currentTagInput}
//               onChange={handleTagInputChange}
//               onKeyDown={handleAddTag}
//               fullWidth
//               margin="normal"
//               placeholder="e.g., politics, economy, sports"
//               helperText="Press Enter or comma to add a tag."
//             />
//             {formData.tags.length > 0 && (
//               <Box sx={{ my: 1 }}>
//                 <Typography variant="subtitle2" gutterBottom>Added Tags:</Typography>
//                 <Stack direction="row" spacing={1} flexWrap="wrap">
//                   {formData.tags.map((tag) => (
//                     <Chip
//                       key={tag}
//                       label={tag}
//                       onDelete={handleDeleteTag(tag)}
//                       color="primary"
//                       variant="outlined"
//                     />
//                   ))}
//                 </Stack>
//               </Box>
//             )}

//             <Divider sx={{ my: 3 }} />

//             <Box sx={{ my: 3 }}>
//               <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//                 Local Media & PDF Uploads
//               </Typography>
//               <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
//                 Upload images, videos, directly from your device.
//               </Typography>

//               {/* Section for Images/Videos */}
//               <Typography variant="subtitle1" gutterBottom sx={{ mt: 2, mb: 1, fontWeight: 'medium' }}>
//                 Images and Videos
//               </Typography>
//                <Typography variant="caption" display="block" sx={{ mb: 1, color: 'error.main' }}>
//         * Note: Images must be exactly 770x500 pixels.
//       </Typography>
//               <Button
//                 variant="outlined"
//                 component="label"
//                 fullWidth
//                 startIcon={<AttachFileIcon />}
//                 sx={{ mb: 2, py: 1.5 }}
//               >
//                 Select Image/Video Files
//                 <input
//                   type="file"
//                   hidden
//                   onChange={handleFileChange}
//                   multiple
//                   accept="image/*,video/*"
//                 />
//               </Button>
//               {mediaFiles.length > 0 && (
//                 <Box sx={{ mt: 2, mb: 2 }}>
//                   <Typography variant="subtitle2" gutterBottom>Selected Images/Videos:</Typography>
//                   <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
//                     {mediaFiles.map((file) => (
//                       <ListItem
//                         key={file.name + file.size}
//                         secondaryAction={
//                           <IconButton edge="end" aria-label="delete" onClick={handleRemoveMediaFile(file)}>
//                             <DeleteIcon />
//                           </IconButton>
//                         }
//                       >
//                         <ListItemIcon>
//                           {file.type.startsWith('image/') ? <AttachFileIcon color="primary" /> : <VideoFileIcon color="secondary" />}
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={file.name}
//                           secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Box>
//               )}

//               {/* Section for PDF Files */}
//               <Typography variant="subtitle1" gutterBottom sx={{ mt: 3, mb: 1, fontWeight: 'medium' }}>
//                 PDF Documents
//               </Typography>
//               <Button
//                 variant="outlined"
//                 component="label"
//                 fullWidth
//                 startIcon={<PictureAsPdfIcon />}
//                 sx={{ mb: 2, py: 1.5 }}
//               >
//                 Select PDF Files
//                 <input
//                   type="file"
//                   hidden
//                   onChange={handlePdfFileChange}
//                   multiple
//                   accept="application/pdf"
//                 />
//               </Button>
//               {pdfFiles.length > 0 && (
//                 <Box sx={{ mt: 2, mb: 2 }}>
//                   <Typography variant="subtitle2" gutterBottom>Selected PDF Files:</Typography>
//                   <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
//                     {pdfFiles.map((file) => (
//                       <ListItem
//                         key={file.name + file.size}
//                         secondaryAction={
//                           <IconButton edge="end" aria-label="delete" onClick={handleRemovePdfFile(file)}>
//                             <DeleteIcon />
//                           </IconButton>
//                         }
//                       >
//                         <ListItemIcon>
//                           <PictureAsPdfIcon color="error" />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={file.name}
//                           secondary={`${(file.size / 1024).toFixed(2)} KB`}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Box>
//               )}

//               <Divider sx={{ my: 3 }} />

            
            
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             <Box sx={{ my: 3 }}>
//               <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//                 Publication Options
//               </Typography>

//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={formData.isHeadline || false}
//                     onChange={(e) =>
//                       setFormData(prev => ({ ...prev, isHeadline: e.target.checked }))
//                     }
//                     name="isHeadline"
//                     color="primary"
//                   />
//                 }
//                 label={
//                   <Box>
//                     <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                       Make this news a headline
//                     </Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       Headlines appear prominently on the homepage and category pages
//                     </Typography>
//                   </Box>
//                 }
//               />
//             </Box>

//             <Box sx={{ mt: 4, textAlign: 'center' }}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size="large"
//                 sx={{
//                   py: 2,
//                   px: 6,
//                   fontSize: '1.1rem',
//                   fontWeight: 'bold',
//                   borderRadius: 2,
//                   boxShadow: 3,
//                   '&:hover': {
//                     boxShadow: 6,
//                   }
//                 }}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
//                     Creating News...
//                   </>
//                 ) : (
//                   'Create News Article'
//                 )}
//               </Button>
//             </Box>
//           </form>
//         </Paper>
//       </Grid>
//     </Grid>
//   );
// };

// export default CreateNews;




 
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  TextField, Button, Grid, Paper, Typography, MenuItem, Box,
  Alert, CircularProgress, Chip, Stack, List, ListItem,
  ListItemText, ListItemIcon, IconButton, Divider,
  FormControlLabel, Checkbox
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import LinkIcon from '@mui/icons-material/Link';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
 
import { createNewsbyAdmin, uploadMediaFiles } from '../../../services/adminService';
import {
  getCategories,
  getSubcategories,
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from '../../../services/apiService';
 
// ─────────────────────────────────────────────
// TinyMCE FREE CDN Wrapper (No API Key Needed)
// Uses tinymce from CDN via useEffect script injection
// ─────────────────────────────────────────────
const TinyEditor = ({ value, onEditorChange, editorRef, config, id }) => {
  const containerRef = useRef(null);
  const editorInstanceRef = useRef(null);
  const isInitialized = useRef(false);
 
  useEffect(() => {
    const initEditor = () => {
      if (!window.tinymce || !containerRef.current || isInitialized.current) return;
      isInitialized.current = true;
 
      const textarea = containerRef.current.querySelector('textarea');
      if (!textarea) return;
 
      window.tinymce.init({
        target: textarea,
        ...config,
        setup: (editor) => {
          editorInstanceRef.current = editor;
          if (editorRef) editorRef.current = editor;
          if (config.setup) config.setup(editor);
          editor.on('init', () => {
            if (value) editor.setContent(value);
          });
          editor.on('input change keyup', () => {
            if (onEditorChange) onEditorChange(editor.getContent());
          });
        },
      });
    };
 
    if (window.tinymce) {
      initEditor();
    } else {
      const existing = document.getElementById('tinymce-cdn-script');
      if (!existing) {
        const script = document.createElement('script');
        script.id = 'tinymce-cdn-script';
        script.src = 'https://cdn.jsdelivr.net/npm/tinymce@6/tinymce.min.js';
        script.referrerPolicy = 'origin';
        script.onload = () => setTimeout(initEditor, 100);
        document.head.appendChild(script);
      } else {
        existing.addEventListener('load', () => setTimeout(initEditor, 100));
      }
    }
 
    return () => {
      if (editorInstanceRef.current) {
        try {
          editorInstanceRef.current.remove();
        } catch (e) {}
        editorInstanceRef.current = null;
        isInitialized.current = false;
      }
    };
  }, []);
 
  // Sync value from outside only when it's cleared (reset)
  useEffect(() => {
    if (editorInstanceRef.current && value === '') {
      editorInstanceRef.current.setContent('');
    }
  }, [value]);
 
  return (
    <div ref={containerRef}>
      <textarea id={id} defaultValue={value} style={{ visibility: 'hidden', height: 0 }} />
    </div>
  );
};
 
// ─────────────────────────────────────────────
const RASHI_OPTIONS = [
  "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
  "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
];
 
const isValidUrl = (string) => {
  try { new URL(string); return true; } catch (e) { return false; }
};
 
// ─────────────────────────────────────────────
const CreateNews = () => {
  const [formData, setFormData] = useState({
    title_en: '',
    title_hi: '',
    summary_en: '',
    summary_hi: '',
    content_en: '',
    content_hi: '',
    category: '',
    subCategory: '',
    subSubCategory: '',
    tags: [],
    mediaUrls: [],
    referenceLinks: [],
    localAddress: '',
    status: '',
    country: '',
    state: '',
    city: '',
    isHeadline: false,
    poll: { question: '', options: [] }
  });
 
  const [showEnglishFields, setShowEnglishFields] = useState(true);
  const [showHindiFields, setShowHindiFields] = useState(true);
 
  const [pollOptionInput, setPollOptionInput] = useState('');
  const [currentTagInput, setCurrentTagInput] = useState('');
  const [mediaFiles, setMediaFiles] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [mediaUrlInput, setMediaUrlInput] = useState('');
  const [referenceLinkInput, setReferenceLinkInput] = useState('');
 
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [formErrors, setFormErrors] = useState({});
 
  // TinyMCE editor refs
  const editorRefEn = useRef(null);
  const editorRefHi = useRef(null);
  const editorRefTitleEn = useRef(null);
  const editorRefTitleHi = useRef(null);
 
  // Track uploaded URLs from editor (avoid closure issues)
  const mediaUrlsRef = useRef([]);
  useEffect(() => { mediaUrlsRef.current = formData.mediaUrls; }, [formData.mediaUrls]);
 
  // ─────────────────────────────────────────────
  // TinyMCE Config — Headline (minimal)
  // ─────────────────────────────────────────────
  const headlineEditorConfig = {
    height: 180,
    menubar: false,
    branding: false,
    license_key: 'gpl',
    plugins: ['lists', 'link', 'searchreplace', 'wordcount'],
    toolbar: 'undo redo | italic underline | fontsizeselect | forecolor backcolor | removeformat',
    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
    forced_root_block: 'p',
    paste_as_text: true,
    invalid_styles: 'font-size font-family',
    content_style: `body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; }`,
  };
 
  // ─────────────────────────────────────────────
  // TinyMCE Config — Full Content Editor
  // ─────────────────────────────────────────────
  const buildEditorConfig = useCallback(() => ({
    height: 500,
    menubar: true,
    branding: false,
    license_key: 'gpl',
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
      'codesample', 'hr', 'nonbreaking', 'directionality', 'quickbars'
    ],
    toolbar1: 'undo redo | bold italic underline strikethrough   | alignleft aligncenter alignright alignjustify',
    toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview print',
    toolbar3: 'insertfile image media link anchor codesample | customupload | ltr rtl',
    content_style: `
      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; font-size: 14px; line-height: 1.6; margin: 1rem; }
      img { max-width: 100%; height: auto; }
    `,
    paste_data_images: true,
    automatic_uploads: true,
    file_picker_types: 'image media',
    file_picker_callback: function (callback, value, meta) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      if (meta.filetype === 'image') input.setAttribute('accept', 'image/*');
      else if (meta.filetype === 'media') input.setAttribute('accept', 'video/*,audio/*');
      else input.setAttribute('accept', 'image/*,video/*,audio/*');
 
      input.onchange = function () {
        const file = this.files[0];
        if (!file) return;
        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);
        const fd = new FormData();
        fd.append('mediaFiles', file);
        uploadMediaFiles(fd)
          .then(response => {
            editor.setProgressState(false);
            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              const currentUrls = [...mediaUrlsRef.current];
              if (!currentUrls.includes(uploadedUrl)) {
                currentUrls.push(uploadedUrl);
                mediaUrlsRef.current = currentUrls;
                setFormData(prev => ({ ...prev, mediaUrls: currentUrls }));
              }
              callback(uploadedUrl, { title: file.name, alt: file.name });
              editor.notificationManager.open({ text: `File "${file.name}" uploaded!`, type: 'success', timeout: 3000 });
            } else throw new Error('No URL returned');
          })
          .catch(err => {
            editor.setProgressState(false);
            editor.notificationManager.open({ text: `Upload failed: ${err.message}`, type: 'error', timeout: 5000 });
          });
      };
      input.click();
    },
    images_upload_handler: function (blobInfo, progress) {
      return new Promise((resolve, reject) => {
        const blob = blobInfo.blob();
        const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, { type: blob.type || 'image/png' });
        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);
        const fd = new FormData();
        fd.append('mediaFiles', file);
        uploadMediaFiles(fd)
          .then(response => {
            editor.setProgressState(false);
            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              const currentUrls = [...mediaUrlsRef.current];
              if (!currentUrls.includes(uploadedUrl)) {
                currentUrls.push(uploadedUrl);
                mediaUrlsRef.current = currentUrls;
                setFormData(prev => ({ ...prev, mediaUrls: currentUrls }));
              }
              resolve(uploadedUrl);
            } else reject(new Error('No URL returned'));
          })
          .catch(err => { editor.setProgressState(false); reject(err); });
      });
    },
    setup: function (editor) {
      editor.ui.registry.addButton('customupload', {
        text: 'Upload Media',
        icon: 'upload',
        tooltip: 'Upload images or videos',
        onAction: function () {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*,video/*');
          input.setAttribute('multiple', 'true');
          input.onchange = function () {
            const files = Array.from(this.files);
            if (!files.length) return;
            editor.setProgressState(true);
            const fd = new FormData();
            files.forEach(f => fd.append('mediaFiles', f));
            uploadMediaFiles(fd)
              .then(response => {
                editor.setProgressState(false);
                if (response && response.locations && response.locations.length > 0) {
                  const currentUrls = [...mediaUrlsRef.current];
                  const newUrls = response.locations.filter(u => !currentUrls.includes(u));
                  const updatedUrls = [...currentUrls, ...newUrls];
                  mediaUrlsRef.current = updatedUrls;
                  setFormData(prev => ({ ...prev, mediaUrls: updatedUrls }));
                  response.locations.forEach((url, i) => {
                    const f = files[i];
                    if (f && f.type.startsWith('image/')) {
                      editor.insertContent(`<img src="${url}" alt="${f.name}" style="max-width: 100%; height: auto;" />`);
                    } else if (f && f.type.startsWith('video/')) {
                      editor.insertContent(`<video controls style="max-width: 100%; height: auto;"><source src="${url}" type="${f.type}">Your browser does not support the video tag.</video>`);
                    }
                  });
                  editor.notificationManager.open({ text: `Uploaded ${response.locations.length} file(s)!`, type: 'success', timeout: 3000 });
                }
              })
              .catch(err => { editor.setProgressState(false); editor.notificationManager.open({ text: `Upload failed: ${err.message}`, type: 'error', timeout: 5000 }); });
          };
          input.click();
        }
      });
    },
     contextmenu: 'link image table',
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_insert_toolbar: 'quickimage quicktable customupload',
    image_advtab: true,
    image_uploadtab: true,
    image_caption: true,
    image_title: true,
    formats: {
      bold: { inline: 'strong' },
      italic: { inline: 'em' },
      underline: { inline: 'u' },
      strikethrough: { inline: 'del' },
    }
  }), []);
 
  // ── Initial data fetch ──
  useEffect(() => {
    const fetchInitialDropdownData = async () => {
      try {
        const [catsRes, countriesRes] = await Promise.all([getCategories(), getCountries()]);
        setCategories(catsRes.data);
        setCountries(countriesRes.data);
      } catch (err) {
        setError('Failed to load initial dropdown data.');
      }
    };
    fetchInitialDropdownData();
  }, []);
 
  const fetchSubCategoriesData = useCallback(async () => {
    if (formData.category) {
      try {
        const response = await getSubcategories(formData.category);
        setSubCategories(response.data);
      } catch (err) {
        setError('Failed to load subcategories.');
        setSubCategories([]);
      }
    } else { setSubCategories([]); }
    setFormData(prev => ({ ...prev, subCategory: '', subSubCategory: '' }));
  }, [formData.category]);
  useEffect(() => { fetchSubCategoriesData(); }, [fetchSubCategoriesData]);
 
  const fetchStatesData = useCallback(async () => {
    if (formData.country) {
      try {
        const response = await getStatesByCountry(formData.country);
        setStates(response.data);
      } catch (err) { setStates([]); }
    } else { setStates([]); }
    setFormData(prev => ({ ...prev, state: '', city: '' }));
  }, [formData.country]);
  useEffect(() => { fetchStatesData(); }, [fetchStatesData]);
 
  const fetchCitiesData = useCallback(async () => {
    if (formData.state) {
      try {
        const response = await getCitiesByState(formData.state);
        setCities(response.data);
      } catch (err) { setCities([]); }
    } else { setCities([]); }
    setFormData(prev => ({ ...prev, city: '' }));
  }, [formData.state]);
  useEffect(() => { fetchCitiesData(); }, [fetchCitiesData]);
 
  const selectedCategoryName = categories.find(cat => cat._id === formData.category)?.name?.toLowerCase();
  const selectedSubCategoryName = subCategories.find(sub => sub._id === formData.subCategory)?.name?.toLowerCase();
  const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';
 
  // ── Handlers ──
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: '' }));
  };
 
  const handleEditorChange = (content, name) => {
    setFormData(prev => ({ ...prev, [name]: content }));
    setFormErrors(prev => ({ ...prev, [name]: '' }));
  };
 
  const handleTagInputChange = (e) => setCurrentTagInput(e.target.value);
 
  const handleAddTag = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const newTag = currentTagInput.trim();
      if (newTag && !formData.tags.includes(newTag)) {
        setFormData(prev => ({ ...prev, tags: [...prev.tags, newTag] }));
        setCurrentTagInput('');
      }
    }
  };
 
  const handleDeleteTag = (tagToDelete) => () =>
    setFormData(prev => ({ ...prev, tags: prev.tags.filter(t => t !== tagToDelete) }));
 
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setMediaFiles(prev => {
      const newFiles = files.filter(f => !prev.some(p => p.name === f.name && p.size === f.size));
      return [...prev, ...newFiles];
    });
    e.target.value = '';
  };
 
  const handlePdfFileChange = (e) => {
    const files = Array.from(e.target.files);
    setPdfFiles(prev => {
      const newFiles = files.filter(f => !prev.some(p => p.name === f.name && p.size === f.size));
      return [...prev, ...newFiles];
    });
    e.target.value = '';
  };
 
  const handleRemoveMediaFile = (file) => () => setMediaFiles(prev => prev.filter(f => f !== file));
  const handleRemovePdfFile = (file) => () => setPdfFiles(prev => prev.filter(f => f !== file));
 
  const handleMediaUrlInputChange = (e) => {
    setMediaUrlInput(e.target.value);
    setFormErrors(prev => ({ ...prev, mediaUrlInput: '' }));
  };
 
  const handleAddMediaUrl = () => {
    const url = mediaUrlInput.trim();
    if (!url) return;
    if (!isValidUrl(url)) { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' })); return; }
    if (formData.mediaUrls.includes(url)) { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'This URL has already been added.' })); return; }
    setFormData(prev => ({ ...prev, mediaUrls: [...prev.mediaUrls, url] }));
 
    // Insert into active TinyMCE editor
    const activeEditor = window.tinymce && window.tinymce.activeEditor;
    if (activeEditor) {
      const isImage = /\.(jpg|jpeg|png|gif|webp|svg|bmp)(\?.*)?$/i.test(url);
      const isVideo = /\.(mp4|webm|ogg|mov|avi|mkv)(\?.*)?$/i.test(url);
      if (isImage) {
        activeEditor.insertContent(`<img src="${url}" alt="media" style="max-width: 100%; height: auto;" />`);
      } else if (isVideo) {
        activeEditor.insertContent(`<video controls style="max-width: 100%; height: auto;"><source src="${url}">Your browser does not support the video tag.</video>`);
      } else {
        activeEditor.insertContent(`<a href="${url}" target="_blank">${url}</a>`);
      }
    }
    setMediaUrlInput('');
  };
 
  const handleRemoveMediaUrl = (urlToRemove) => () =>
    setFormData(prev => ({ ...prev, mediaUrls: prev.mediaUrls.filter(u => u !== urlToRemove) }));
 
  const handleReferenceLinkInputChange = (e) => {
    setReferenceLinkInput(e.target.value);
    setFormErrors(prev => ({ ...prev, referenceLinkInput: '' }));
  };
 
  const handleAddReferenceLink = () => {
    const link = referenceLinkInput.trim();
    if (!link) return;
    if (!isValidUrl(link)) { setFormErrors(prev => ({ ...prev, referenceLinkInput: 'Please enter a valid URL.' })); return; }
    if (!formData.referenceLinks.includes(link)) {
      setFormData(prev => ({ ...prev, referenceLinks: [...prev.referenceLinks, link] }));
      setReferenceLinkInput('');
    } else {
      setFormErrors(prev => ({ ...prev, referenceLinkInput: 'This link has already been added.' }));
    }
  };
 
  const handleRemoveReferenceLink = (linkToRemove) => () =>
    setFormData(prev => ({ ...prev, referenceLinks: prev.referenceLinks.filter(l => l !== linkToRemove) }));
 
  const handlePollChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, poll: { ...prev.poll, [name]: value } }));
  };
 
  const handleAddPollOption = () => {
    const newOption = pollOptionInput.trim();
    if (newOption && !formData.poll.options.includes(newOption)) {
      setFormData(prev => ({ ...prev, poll: { ...prev.poll, options: [...prev.poll.options, newOption] } }));
      setPollOptionInput('');
    }
  };
 
  const handleDeletePollOption = (opt) => () =>
    setFormData(prev => ({ ...prev, poll: { ...prev.poll, options: prev.poll.options.filter(o => o !== opt) } }));
 
  // ── Validation ──
  const validateForm = () => {
    let errors = {};
    let isValid = true;
 
    if (!showEnglishFields && !showHindiFields) {
      errors.languageSelection = 'Please select at least one language.';
      isValid = false;
    }
    if (showEnglishFields) {
      if (!formData.title_en.trim()) { errors.title_en = 'Title (English) is required.'; isValid = false; }
      if (!formData.content_en.trim()) { errors.content_en = 'Content (English) is required.'; isValid = false; }
      else if (formData.content_en.trim().length < 20) { errors.content_en = 'Content (English) must be at least 20 characters.'; isValid = false; }
      if (formData.summary_en.trim().length > 500) { errors.summary_en = 'Summary cannot exceed 500 characters.'; isValid = false; }
    }
    if (showHindiFields) {
      if (!formData.title_hi.trim()) { errors.title_hi = 'शीर्षक (हिंदी) आवश्यक है।'; isValid = false; }
      if (!formData.content_hi.trim()) { errors.content_hi = 'सामग्री (हिंदी) आवश्यक है।'; isValid = false; }
      if (formData.summary_hi.trim().length > 500) { errors.summary_hi = 'सारांश 500 अक्षरों से अधिक नहीं हो सकता।'; isValid = false; }
    }
    if (!formData.category) { errors.category = 'Category is required.'; isValid = false; }
 
    setFormErrors(errors);
    return isValid;
  };
 
  // ── Submit ──
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    // Get latest content from TinyMCE before submit
    if (editorRefEn.current) setFormData(prev => ({ ...prev, content_en: editorRefEn.current.getContent() }));
    if (editorRefHi.current) setFormData(prev => ({ ...prev, content_hi: editorRefHi.current.getContent() }));
    if (editorRefTitleEn.current) setFormData(prev => ({ ...prev, title_en: editorRefTitleEn.current.getContent() }));
    if (editorRefTitleHi.current) setFormData(prev => ({ ...prev, title_hi: editorRefTitleHi.current.getContent() }));
 
    // Small delay to let state settle
    await new Promise(r => setTimeout(r, 50));
 
    if (!validateForm()) { setError('Please correct the errors in the form.'); return; }
 
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
 
    const finalTags = [...formData.tags];
    const remainingTag = currentTagInput.trim();
    if (remainingTag && !finalTags.includes(remainingTag)) finalTags.push(remainingTag);
 
    let updatedMediaUrls = [...formData.mediaUrls];
    const currentMediaUrl = mediaUrlInput.trim();
    if (currentMediaUrl) {
      if (!isValidUrl(currentMediaUrl)) {
        setFormErrors(prev => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
        setLoading(false); return;
      }
      if (!updatedMediaUrls.includes(currentMediaUrl)) updatedMediaUrls.push(currentMediaUrl);
    }
 
    let updatedReferenceLinks = [...formData.referenceLinks];
    const currentReferenceLink = referenceLinkInput.trim();
    if (currentReferenceLink) {
      if (!isValidUrl(currentReferenceLink)) {
        setFormErrors(prev => ({ ...prev, referenceLinkInput: 'Please enter a valid URL.' }));
        setLoading(false); return;
      }
      if (!updatedReferenceLinks.includes(currentReferenceLink)) updatedReferenceLinks.push(currentReferenceLink);
    }
 
    const dataToSend = new FormData();
 
    // Get fresh content from editors
    const content_en_final = editorRefEn.current ? editorRefEn.current.getContent() : formData.content_en;
    const content_hi_final = editorRefHi.current ? editorRefHi.current.getContent() : formData.content_hi;
    const title_en_final = editorRefTitleEn.current ? editorRefTitleEn.current.getContent() : formData.title_en;
    const title_hi_final = editorRefTitleHi.current ? editorRefTitleHi.current.getContent() : formData.title_hi;
 
    if (showEnglishFields) {
      dataToSend.append('title_en', title_en_final.trim());
      dataToSend.append('summary_en', formData.summary_en.trim());
      dataToSend.append('content_en', content_en_final.trim());
    } else {
      dataToSend.append('title_en', ''); dataToSend.append('summary_en', ''); dataToSend.append('content_en', '');
    }
 
    if (showHindiFields) {
      dataToSend.append('title_hi', title_hi_final.trim());
      dataToSend.append('summary_hi', formData.summary_hi.trim());
      dataToSend.append('content_hi', content_hi_final.trim());
    } else {
      dataToSend.append('title_hi', ''); dataToSend.append('summary_hi', ''); dataToSend.append('content_hi', '');
    }
 
    dataToSend.append('category', formData.category);
    if (formData.subCategory) dataToSend.append('subCategory', formData.subCategory);
    if (formData.subSubCategory) dataToSend.append('subSubCategory', formData.subSubCategory);
    if (formData.isHeadline) dataToSend.append('isHeadline', true);
    if (formData.country) dataToSend.append('country', formData.country);
    if (formData.state) dataToSend.append('state', formData.state);
    if (formData.city) dataToSend.append('city', formData.city);
    finalTags.forEach(tag => dataToSend.append('tags', tag));
    if (formData.localAddress) dataToSend.append('localAddress', formData.localAddress.trim());
 
    mediaFiles.forEach(file => dataToSend.append('mediaFiles', file));
    pdfFiles.forEach(file => dataToSend.append('mediaFiles', file));
 
    const uniqueMediaUrls = [...new Set([...updatedMediaUrls, ...mediaUrlsRef.current])];
    uniqueMediaUrls.forEach(url => dataToSend.append('mediaUrls', url));
    updatedReferenceLinks.forEach(link => dataToSend.append('referenceLinks', link));
 
    if (formData.poll.question.trim() && formData.poll.options.length > 0) {
      dataToSend.append('poll[question]', formData.poll.question.trim());
      formData.poll.options.forEach((opt, i) => dataToSend.append(`poll[options][${i}]`, opt.trim()));
    }
 
    try {
      const response = await createNewsbyAdmin(dataToSend);
      setSuccessMessage(response.message || 'News created successfully!');
 
      setFormData({
        title_en: '', title_hi: '', summary_en: '', summary_hi: '',
        content_en: '', content_hi: '', category: '', subCategory: '',
        subSubCategory: '', tags: [], mediaUrls: [], referenceLinks: [],
        localAddress: '', status: '', country: '', state: '', city: '',
        isHeadline: false, poll: { question: '', options: [] }
      });
      mediaUrlsRef.current = [];
      setPollOptionInput(''); setCurrentTagInput('');
      setMediaFiles([]); setPdfFiles([]);
      setMediaUrlInput(''); setReferenceLinkInput('');
      setSubCategories([]); setStates([]); setCities([]);
 
      // Clear TinyMCE editors
      if (editorRefEn.current) editorRefEn.current.setContent('');
      if (editorRefHi.current) editorRefHi.current.setContent('');
      if (editorRefTitleEn.current) editorRefTitleEn.current.setContent('');
      if (editorRefTitleHi.current) editorRefTitleHi.current.setContent('');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to create news.');
    } finally {
      setLoading(false);
    }
  };
 
  const editorConfig = buildEditorConfig();
 
  // ─────────────────────────────────────────────
  return (
    <Grid container justifyContent="center" sx={{ mt: 4, mb: 4 }}>
      <Grid item xs={12} md={10} lg={8}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{ fontWeight: 'bold', color: 'primary.main', textTransform: 'uppercase', letterSpacing: 1.5, mb: 3 }}
          >
            📰 Create New News Post (Advanced Editor)
          </Typography>
 
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}
          {formErrors.languageSelection && <Alert severity="warning" sx={{ mb: 2 }}>{formErrors.languageSelection}</Alert>}
 
          <form onSubmit={handleSubmit}>
 
            {/* ── Language Selection ── */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>Select Content Languages</Typography>
              <Stack direction="row" spacing={3}>
                <FormControlLabel
                  control={<Checkbox checked={showEnglishFields} onChange={(e) => setShowEnglishFields(e.target.checked)} color="primary" />}
                  label="English Fields"
                />
                <FormControlLabel
                  control={<Checkbox checked={showHindiFields} onChange={(e) => setShowHindiFields(e.target.checked)} color="primary" />}
                  label="Hindi Fields"
                />
              </Stack>
            </Box>
            <Divider sx={{ my: 3 }} />
 
            {/* ── English Content ── */}
            {showEnglishFields && (
              <Box sx={{ mb: 4, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                  English Content
                </Typography>
 
                <Typography variant="body2" color="textSecondary" gutterBottom>Title (English) *</Typography>
                <Box sx={{ border: formErrors.title_en ? '1px solid red' : '1px solid #ccc', borderRadius: 1, mb: 1 }}>
                  <TinyEditor
                    id="title_en_editor"
                    value={formData.title_en}
                    onEditorChange={(content) => handleEditorChange(content, 'title_en')}
                    editorRef={editorRefTitleEn}
                    config={headlineEditorConfig}
                  />
                </Box>
                {formErrors.title_en && <Typography color="error" variant="caption">{formErrors.title_en}</Typography>}
 
                <TextField
                  label="Summary (English)"
                  name="summary_en"
                  value={formData.summary_en}
                  onChange={handleChange}
                  fullWidth multiline rows={2} margin="normal"
                  inputProps={{ maxLength: 500 }}
                  error={!!formErrors.summary_en}
                  helperText={formErrors.summary_en}
                />
 
 
                <Box sx={{ mt: 3, mb: 1 }}>
                  <Typography variant="body2" color="textSecondary" gutterBottom>Content (English) * (MS Word-like Editor)</Typography>
                  <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
                    <TinyEditor
                      id="content_en_editor"
                      value={formData.content_en}
                      onEditorChange={(content) => handleEditorChange(content, 'content_en')}
                      editorRef={editorRefEn}
                      config={editorConfig}
                    />
                  </Box>
                  {formErrors.content_en && (
                    <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.content_en}</Typography>
                  )}
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                    Use the toolbar above for rich text formatting, tables, images, links, and more. You can paste directly from MS Word!
                  </Typography>
                </Box>
              </Box>
            )}
 
            {/* ── Hindi Content ── */}
            {showHindiFields && (
              <Box sx={{ mb: 4, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                  हिंदी सामग्री
                </Typography>
 
                <Typography variant="body2" color="textSecondary" gutterBottom>शीर्षक (हिंदी) *</Typography>
                <Box sx={{ border: formErrors.title_hi ? '1px solid red' : '1px solid #ccc', borderRadius: 1, mb: 1 }}>
                  <TinyEditor
                    id="title_hi_editor"
                    value={formData.title_hi}
                    onEditorChange={(content) => handleEditorChange(content, 'title_hi')}
                    editorRef={editorRefTitleHi}
                    config={headlineEditorConfig}
                  />
                </Box>
                {formErrors.title_hi && <Typography color="error" variant="caption">{formErrors.title_hi}</Typography>}
 
                <TextField
                  label="सारांश (हिंदी)"
                  name="summary_hi"
                  value={formData.summary_hi}
                  onChange={handleChange}
                  fullWidth multiline rows={2} margin="normal"
                  inputProps={{ maxLength: 500 }}
                  error={!!formErrors.summary_hi}
                  helperText={formErrors.summary_hi}
                />
 
                <Box sx={{ mt: 3, mb: 1 }}>
                  <Typography variant="body2" color="textSecondary" gutterBottom>सामग्री (हिंदी) * (MS Word जैसा एडिटर)</Typography>
                  <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
                    <TinyEditor
                      id="content_hi_editor"
                      value={formData.content_hi}
                      onEditorChange={(content) => handleEditorChange(content, 'content_hi')}
                      editorRef={editorRefHi}
                      config={editorConfig}
                    />
                  </Box>
                  {formErrors.content_hi && (
                    <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.content_hi}</Typography>
                  )}
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                    टूलबार का उपयोग करके रिच टेक्स्ट फॉर्मेटिंग, टेबल, चित्र, लिंक आदि जोड़ें। आप सीधे MS Word से पेस्ट कर सकते हैं!
                  </Typography>
                </Box>
              </Box>
            )}
 
            {/* ── Category / Subcategory ── */}
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Category" name="category" select
                  value={formData.category} onChange={handleChange}
                  fullWidth margin="normal"
                  error={!!formErrors.category} helperText={formErrors.category || 'Select the primary category for this news.'}
                >
                  <MenuItem value="">Select Category</MenuItem>
                  {categories.map(cat => <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Subcategory" name="subCategory" select
                  value={formData.subCategory} onChange={handleChange}
                  fullWidth margin="normal"
                  disabled={!formData.category || subCategories.length === 0}
                  helperText="Select a subcategory if available (optional)."
                >
                  <MenuItem value="">Select Subcategory (Optional)</MenuItem>
                  {subCategories.map(sub => <MenuItem key={sub._id} value={sub._id}>{sub.name}</MenuItem>)}
                </TextField>
              </Grid>
            </Grid>
 
            {showSubSubCategoryDropdown && (
              <TextField
                label="Select Rashi (subSubCategory)" name="subSubCategory" select fullWidth margin="normal"
                value={formData.subSubCategory} onChange={handleChange}
              >
                <MenuItem value="">Select Rashi</MenuItem>
                {RASHI_OPTIONS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
              </TextField>
            )}
 
            {/* ── Location ── */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <TextField label="Country" name="country" select value={formData.country} onChange={handleChange} fullWidth margin="normal" helperText="Select the country where the news originates.">
                  <MenuItem value="">Select Country (Optional)</MenuItem>
                  {countries.map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField label="State" name="state" select value={formData.state} onChange={handleChange} fullWidth margin="normal" disabled={!formData.country || states.length === 0} helperText="Select the state (optional).">
                  <MenuItem value="">Select State (Optional)</MenuItem>
                  {states.map(s => <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField label="City/District" name="city" select value={formData.city} onChange={handleChange} fullWidth margin="normal" disabled={!formData.state || cities.length === 0} helperText="Select the city or district (optional).">
                  <MenuItem value="">Select City/District (Optional)</MenuItem>
                  {cities.map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
                </TextField>
              </Grid>
            </Grid>
 
            <TextField label="Local Address (Optional)" name="localAddress" value={formData.localAddress} onChange={handleChange} fullWidth margin="normal" inputProps={{ maxLength: 200 }} />
 
            {/* ── Tags ── */}
            <TextField
              label="Tags (Type, then press Enter or comma)"
              value={currentTagInput} onChange={handleTagInputChange} onKeyDown={handleAddTag}
              fullWidth margin="normal" placeholder="e.g., politics, economy, sports"
              helperText="Press Enter or comma to add a tag."
            />
            {formData.tags.length > 0 && (
              <Box sx={{ my: 1 }}>
                <Typography variant="subtitle2" gutterBottom>Added Tags:</Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {formData.tags.map(tag => (
                    <Chip key={tag} label={tag} onDelete={handleDeleteTag(tag)} color="primary" variant="outlined" />
                  ))}
                </Stack>
              </Box>
            )}
 
            <Divider sx={{ my: 3 }} />
 
            {/* ── Media Upload (Files) ── */}
            <Box sx={{ my: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Local Media & PDF Uploads
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
                Upload images, videos, directly from your device.
              </Typography>
 
              <Typography variant="subtitle1" gutterBottom sx={{ mt: 2, mb: 1, fontWeight: 'medium' }}>Images and Videos</Typography>
              <Typography variant="caption" display="block" sx={{ mb: 1, color: 'error.main' }}>
                * Note: Images must be exactly 770x500 pixels.
              </Typography>
              <Button variant="outlined" component="label" fullWidth startIcon={<AttachFileIcon />} sx={{ mb: 2, py: 1.5 }}>
                Select Image/Video Files
                <input type="file" hidden onChange={handleFileChange} multiple accept="image/*,video/*" />
              </Button>
              {mediaFiles.length > 0 && (
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0', mb: 2 }}>
                  {mediaFiles.map(file => (
                    <ListItem key={file.name + file.size} secondaryAction={<IconButton edge="end" onClick={handleRemoveMediaFile(file)}><DeleteIcon /></IconButton>}>
                      <ListItemIcon>{file.type.startsWith('image/') ? <AttachFileIcon color="primary" /> : <VideoFileIcon color="secondary" />}</ListItemIcon>
                      <ListItemText primary={file.name} secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`} />
                    </ListItem>
                  ))}
                </List>
              )}
 
              <Typography variant="subtitle1" gutterBottom sx={{ mt: 3, mb: 1, fontWeight: 'medium' }}>PDF Documents</Typography>
              <Button variant="outlined" component="label" fullWidth startIcon={<PictureAsPdfIcon />} sx={{ mb: 2, py: 1.5 }}>
                Select PDF Files
                <input type="file" hidden onChange={handlePdfFileChange} multiple accept="application/pdf" />
              </Button>
              {pdfFiles.length > 0 && (
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0', mb: 2 }}>
                  {pdfFiles.map(file => (
                    <ListItem key={file.name + file.size} secondaryAction={<IconButton edge="end" onClick={handleRemovePdfFile(file)}><DeleteIcon /></IconButton>}>
                      <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                      <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB`} />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
 
            <Divider sx={{ my: 3 }} />
 
            {/* ── Media URL (Insert into Editor) ── */}
            <Box sx={{ my: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Insert Media via URL
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Image ya Video URL daalo — directly editor mein insert ho jayega.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', mt: 1 }}>
                <TextField
                  label="Media URL (Image / Video)"
                  value={mediaUrlInput}
                  onChange={handleMediaUrlInputChange}
                  fullWidth
                  placeholder="https://example.com/image.jpg"
                  error={!!formErrors.mediaUrlInput}
                  helperText={formErrors.mediaUrlInput || 'Supported: jpg, png, gif, webp, mp4, webm, mov'}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddMediaUrl(); } }}
                />
                <Button variant="contained" onClick={handleAddMediaUrl} startIcon={<AddCircleOutlineIcon />} sx={{ mt: 1, whiteSpace: 'nowrap', py: 1.8 }}>
                  Insert in Editor
                </Button>
              </Box>
              {formData.mediaUrls.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>Added Media URLs:</Typography>
                  <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                    {formData.mediaUrls.map(url => (
                      <ListItem key={url} secondaryAction={<IconButton edge="end" onClick={handleRemoveMediaUrl(url)}><DeleteIcon /></IconButton>}>
                        <ListItemIcon>
                          {/\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(url) ? <AttachFileIcon color="primary" />
                            : /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url) ? <VideoFileIcon color="secondary" />
                            : <LinkIcon color="action" />}
                        </ListItemIcon>
                        <ListItemText
                          primary={url.length > 60 ? url.substring(0, 60) + '...' : url}
                          secondary={
                            /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(url) ? 'Image'
                              : /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url) ? 'Video' : 'Link'
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
            </Box>
 
            <Divider sx={{ my: 3 }} />
 
            {/* ── Reference Links ── */}
            <Box sx={{ my: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Reference Links
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <TextField
                  label="Reference Link URL"
                  value={referenceLinkInput}
                  onChange={handleReferenceLinkInputChange}
                  fullWidth
                  placeholder="https://example.com/source"
                  error={!!formErrors.referenceLinkInput}
                  helperText={formErrors.referenceLinkInput}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddReferenceLink(); } }}
                />
                <Button variant="outlined" onClick={handleAddReferenceLink} startIcon={<AddCircleOutlineIcon />} sx={{ mt: 1, whiteSpace: 'nowrap', py: 1.8 }}>
                  Add Link
                </Button>
              </Box>
              {formData.referenceLinks.length > 0 && (
                <List dense sx={{ mt: 2, bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {formData.referenceLinks.map(link => (
                    <ListItem key={link} secondaryAction={<IconButton edge="end" onClick={handleRemoveReferenceLink(link)}><DeleteIcon /></IconButton>}>
                      <ListItemIcon><LinkIcon color="primary" /></ListItemIcon>
                      <ListItemText primary={link.length > 70 ? link.substring(0, 70) + '...' : link} />
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
 
            <Divider sx={{ my: 3 }} />
 
            {/* ── Poll ── */}
            <Box sx={{ my: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Poll (Optional)
              </Typography>
              <TextField label="Poll Question" name="question" value={formData.poll.question} onChange={handlePollChange} fullWidth margin="normal" />
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', mt: 1 }}>
                <TextField
                  label="Poll Option"
                  value={pollOptionInput}
                  onChange={(e) => setPollOptionInput(e.target.value)}
                  fullWidth
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddPollOption(); } }}
                />
                <Button variant="outlined" onClick={handleAddPollOption} startIcon={<AddCircleOutlineIcon />} sx={{ mt: 1, whiteSpace: 'nowrap', py: 1.8 }}>
                  Add Option
                </Button>
              </Box>
              {formData.poll.options.length > 0 && (
                <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
                  {formData.poll.options.map(opt => (
                    <Chip key={opt} label={opt} onDelete={handleDeletePollOption(opt)} color="secondary" variant="outlined" />
                  ))}
                </Stack>
              )}
            </Box>
 
            <Divider sx={{ my: 3 }} />
 
            {/* ── Publication Options ── */}
            <Box sx={{ my: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                Publication Options
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.isHeadline || false}
                    onChange={(e) => setFormData(prev => ({ ...prev, isHeadline: e.target.checked }))}
                    name="isHeadline" color="primary"
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>Make this news a headline</Typography>
                    <Typography variant="caption" color="textSecondary">Headlines appear prominently on the homepage and category pages</Typography>
                  </Box>
                }
              />
            </Box>
 
            {/* ── Submit ── */}
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Button
                type="submit" variant="contained" color="primary" size="large"
                sx={{ py: 2, px: 6, fontSize: '1.1rem', fontWeight: 'bold', borderRadius: 2, boxShadow: 3, '&:hover': { boxShadow: 6 } }}
                disabled={loading}
              >
                {loading ? <><CircularProgress size={24} color="inherit" sx={{ mr: 1 }} /> Creating News...</> : 'Create News Article'}
              </Button>
            </Box>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};
 
export default CreateNews;
 